module.exports = __webpack_public_path__ + "img/logo-small4.eafebd6d.png";